import { listPublishedProducts } from "@/lib/admin/products.functions";
import type { Product, ModelId } from "@/lib/catalog";
import r129 from "@/assets/mercedes-r129.avif.asset.json";
import w124 from "@/assets/mercedes-w124.avif.asset.json";
import w201 from "@/assets/mercedes-w201.avif.asset.json";
import w208 from "@/assets/mercedes-w208.avif.asset.json";

/** Shared query options so the shop page and the navbar search share one cache. */
export const publishedProductsQuery = {
  queryKey: ["shop", "published-products"] as const,
  queryFn: () => listPublishedProducts(),
  staleTime: 60_000,
};

/** Map raw DB rows to the catalog Product shape used by the search engine. */
export function mapDbProducts(rows: any[] | undefined | null): Product[] {
  return (rows ?? []).map((r: any) => ({
    id: r.id,
    sku: r.sku,
    slug: r.slug,
    oem: r.oem ?? [],
    name: r.name,
    brand: r.brand,
    models: r.models ?? [],
    category: r.category ?? "all",
    price: r.price ?? 0,
    currency: (r.currency ?? "EUR") as "EUR",
    inStock: !!r.inStock,
    rating: r.rating ?? 0,
    reviewCount: r.reviewCount ?? 0,
    badges: r.badges ?? [],
    addedAt: r.addedAt ?? new Date().toISOString(),
    image: r.image ?? null,
  }));
}

const MODEL_IMAGES: Partial<Record<ModelId, string>> = {
  r129: r129.url,
  w124: w124.url,
  w201: w201.url,
  w208: w208.url,
};

export function productImageFor(p: Product): string | null {
  if (p.image) return p.image;
  for (const m of p.models) {
    const key = m as ModelId;
    if (MODEL_IMAGES[key]) return MODEL_IMAGES[key]!;
  }
  return null;
}
